export const isImageFile = (filetype: string) => (filetype || "").split("/")[0] === "image";
export const isVideoFile = (filetype: string) => (filetype || "").split("/")[0] === "video";
export const isPDFFile = (filetype: string) => (filetype || "").split("/")[1] === "pdf";
